import Property from "@/components/sections/Property";
import Trails from "@/components/sections/Trails";
import RoadIn from "@/components/sections/RoadIn";
import Sites from "@/components/sections/Sites";
import EditableText from "@/components/editor/EditableText";

function SharedFeatures() {
  return (
    <section className="wc-section bg-white border-t border-wc-driftwood/20" data-testid="shared-features">
      <div className="max-w-6xl mx-auto">
        <header className="max-w-3xl mb-10">
          <p className="font-accent italic text-wc-teal text-base mb-3">Shared across both sites</p>
          <h2 className="font-display text-wc-forest text-3xl sm:text-4xl font-semibold leading-tight">
            What you get, regardless of site.
          </h2>
        </header>
      </div>
      <Property />
    </section>
  );
}

export default function LandPage() {
  return (
    <div className="pt-16">
      {/* Page header */}
      <div className="px-6 sm:px-16 lg:px-24 pt-10 sm:pt-14 bg-wc-cream">
        <div className="max-w-5xl mx-auto">
          <p className="font-accent italic text-wc-teal text-base mb-3">The Land</p>
          <EditableText contentKey="land_heading" as="h1"
            className="font-display text-wc-forest text-4xl sm:text-5xl lg:text-6xl font-bold mb-4"
            defaultValue="Two sites on the Bay of Fundy." />
          <EditableText contentKey="land_subtitle" as="p"
            className="font-body text-wc-slate text-base sm:text-lg max-w-2xl leading-relaxed"
            defaultValue="Private, off-grid, oceanfront — a shared retreat on Digby Neck, Nova Scotia. Site One opens for the 2027 season. Site Two is a longer-term build — the road in is a major project that will take time. Through 2026, we're on the land ourselves, testing every detail." />
        </div>
      </div>

      {/* Two sites — primary feature */}
      <Sites />

      {/* Shared amenities/character */}
      <SharedFeatures />

      <RoadIn />

      {/* Trails */}
      <div id="trails">
        <Trails />
      </div>
    </div>
  );
}
